module.exports = __webpack_public_path__ + "static/media/pt.b908edae.svg";